//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import Button from '@/components/Shared/Button'
import TagStep from '@/components/Shared/TagStep.vue'
import { ValidationObserver } from 'vee-validate'
import IdentificatorField from './Shared/IdentificatorField.vue'
export default {
  components: { ValidationObserver, Button, IdentificatorField, TagStep },
  data: () => ({
    identifier: '',
    identifier_type: 'identification_number',
  }),
  mounted() {
    if (!this.$strapi.user) {
      this.$router.push('/login')
    }
    if (this.$strapi.user?.identification_number) {
      this.$router.push('/inicio')
    }
  },
  methods: {
    onIdentificatorTypeChange(type) {
      this.identifier_type = type
    },
    async saveIdentificator() {
      try {
        this.$store.commit('loading', true)
        const user = {
          id: this.$strapi.user.id,
          identification_number: this.identifier,
        }
        await this.$repository.me.update(user)
        await this.$store.dispatch('me/fetchUser')
        await this.$router.push({ path: '/inicio' })
      } catch (error) {
        const idsOfMessageError = _.toArray(
          _.flatten(
            (error.response?.data?.message || []).map((message) =>
              message.messages.map(({ id }) => id)
            )
          )
        )
        if (
          idsOfMessageError.includes(
            'Auth.form.error.identification_number.taken'
          )
        ) {
          this.$buefy.notification.open({
            message:
              'El número de identificación que ingresaste ya está registrado. Por favor, verifica e intenta nuevamente.',
            type: 'is-danger',
            duration: 5000,
          })
          return
        }
        this.$buefy.notification.open({
          message:
            'Ocurrió un error al registrar tu número de identificación. Por favor, intenta nuevamente.',
          type: 'is-danger',
          duration: 5000,
        })
      } finally {
        this.$store.commit('loading', false)
      }
    },
  },
}
